import { Throbber } from "@lytra/frontend-common";
/**
 * Shown while a lazily-imported route chunk is still downloading.
 *
 * Routes load their page component via `lazy`, so on a cold start React Router
 * has nothing to render until the chunk arrives. Without a HydrateFallback on
 * the root route it truncates the match list to the root and paints a blank
 * screen; this mirrors the pre-boot spinner in index.html so the handoff from
 * static HTML to React is not visible.
 */
export default function RouteFallback() {
  return (
    <div
      className="flex h-screen flex-col items-center justify-center gap-4"
      role="status"
      aria-live="polite"
    >
      <Throbber className="size-10 text-[#D571E5]" />
      <p className="text-sm text-muted-foreground">Anwendung wird geladen...</p>
    </div>
  );
}
